export default __webpack_public_path__ + "static/media/Primary-UploadVideo.1d5f0f06.svg";